export default __webpack_public_path__ + "static/media/logo-ontest.0e8e2a01.png";